// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-document[data-v-369b0b27]{width:20px;height:20px}.mr-2[data-v-369b0b27]{margin-right:.3rem}.white-space[data-v-369b0b27]{white-space:pre-wrap}.check-icon[data-v-369b0b27]{width:16px;height:12px;margin-bottom:-1px}.alert-icon[data-v-369b0b27]{width:18px;height:14px;margin-bottom:-1px}.filename[data-v-369b0b27]{word-wrap:anywhere}.documentname[data-v-369b0b27]{font-weight:500}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
